import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { RxComponent } from '../../../../core/components/common/rx.component';
import { HappyModalService } from '../happy-modal.service';

declare var $: any;

@Component({
    selector: 'itpx-happy-modal',
    templateUrl: './happy-modal.component.html',
    styleUrls: ['./happy-modal.component.css']
})
export class HappyModalComponent extends RxComponent {

    @ViewChild('modal') modalRef: ElementRef;

    constructor(private service: HappyModalService) {
        super();
    }

    ngOnInit() {

        this.service
    }

    show() {
        $(this.modalRef.nativeElement).modal('show');
    }

    hide() {
        $(this.modalRef.nativeElement).modal('hide');
    }
}



// WEBPACK FOOTER //
// ./src/app/phoenix2/common/services/happy-modal/happy-modal.component.ts